<template>
  <div>
    <h3 class="my-3">Summary Report</h3>
    <div>
      <vs-row>
        <vs-col vs-xs="12" vs-sm="10" vs-lg="10" class="px-0 pr-2 mb-base">
          <vs-input class="w-full" placeholder="Type to Search" v-model="filters.search" />
        </vs-col>
        <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="mb-base p-0 flex">
          <vx-tooltip text="Refresh Data" color="primary">
            <vs-button color="primary" type="filled" @click="init()" :disabled="loading">
              <font-awesome-icon :icon="redoIcon" />
            </vs-button>
          </vx-tooltip>
          <vx-tooltip text="Create Excel" color="primary">
            <vs-button color="primary" type="filled" @click="create_excel" class="ml-2" :disabled="loading">
              <font-awesome-icon :icon="excel" />
            </vs-button>
          </vx-tooltip>
        </vs-col>
      </vs-row>
      <!-- filters  -->
      <vs-row>
        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
          <SelectForeign :model.sync="filters.data__contract__portfolio" label="Filter by Portfolio"
            placeholder="Type to Search" :multiple="false" :load_initial="true" :label_keys="['name',]" label_class="mb-0"
            input_class="mt-0 bg-white" :show_id_in_label="false" :endpoint="$store.state.apiendpoints.portfolio_list"
            :use_id_as_value="true" list_length="10000" />
          <small class="block text-danger mt-1" v-if="api_errors && api_errors.data__contract__portfolio">
            {{ api_errors.data__contract__portfolio.join(', ') }}
          </small>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
          <SelectForeign :model.sync="filters.data__share" label="Filter by Share Symbol" placeholder="Type to Search"
            :multiple="false" :load_initial="true" :label_keys="['scrip_name',]" label_class="mb-0"
            input_class="mt-0 bg-white" :show_id_in_label="false" :endpoint="$store.state.apiendpoints.share_list"
            :use_id_as_value="true" list_length="10000" />
          <small class="block text-danger mt-1" v-if="api_errors && api_errors.data__share">
            {{ api_errors.data__share.join(', ') }}
          </small>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
          <InputSelect :model.sync="data__contract_type" label="Filter by contract Type" placeholder="choose ..."
            :options="contract_type_options" :multiple="false" />
        </vs-col>
      </vs-row>

      <!-- list of excel created  -->
      <template v-if="ongoing_exports.length">
        <vs-alert color="primary" v-if="loading_exports">
          Loading Latest Exports, please wait..
        </vs-alert>
        <template v-else>
          <template v-for="(item, index) in ongoing_exports">
            <vs-alert color="primary" :key="index" class="mb-2">
              <template v-if="item.status == 'p'">
                Your export is pending, please check back in few minutes
              </template>
              <template v-else-if="item.status == 's'">
                Your export is in queue, please check back in few minutes
              </template>
              <template v-else-if="item.status == 'r'">
                Your export is being generated, please check back in few minutes
              </template>
              <template v-else-if="item.status == 'c'">
                Your export has been completed. (
                <FormatText :text="item.created_on" format="datetime" />) <a :href="item.export_excel" target="_blank"
                  style="float:right;"><vs-button size="small">Download</vs-button></a>
              </template>
              <template v-else-if="item.status == 'f'">
                Your export has been failed, please request again!
              </template>
            </vs-alert>
          </template>
        </template>
      </template>

      <!-- table  -->
      <vs-table :data="results">
        <vs-tr>
          <vs-th>Portfolio</vs-th>
          <vs-th>Contract Type</vs-th>
          <vs-th>Share Name</vs-th>
          <vs-th>Share Symbol</vs-th>
          <vs-th>Total Qty</vs-th>
          <vs-th>Avg Cost</vs-th>
          <vs-th>Current Market Price</vs-th>
          <vs-th>Total Cost</vs-th>
          <vs-th>Total Market Value</vs-th>
          <vs-th>P&L</vs-th>
        </vs-tr>
        <vs-tr v-for="(item, index) in filteredContracts" :key="index">
          <vs-td>{{ item.portfolio }}</vs-td>
          <vs-td>
            <FormatText :text="item.contract_type" format="select" :kwargs="contract_type_options" />
          </vs-td>
          <vs-td>{{ item.share_name }}</vs-td>
          <vs-td>{{ item.share_symbol }}</vs-td>
          <vs-td>{{ item.total_qty }}</vs-td>
          <vs-td>{{ ((item.total_cost || 0) / (item.total_qty || 1)).toFixed(3) }}</vs-td>
          <vs-td>{{ item.current_market_price }}</vs-td>
          <vs-td>{{ item.total_cost }}</vs-td>
          <vs-td>{{ item.total_market_value }}</vs-td>
          <vs-td>{{ item.pnl }}</vs-td>
        </vs-tr>
      </vs-table>
    </div>
    <vs-row v-if="total_items" class="mt-3">
      <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
    </vs-row>
  </div>
</template>
  
<script>
import { Request } from "../../utils/requests";
import { faRedo, faFileExcel } from '@fortawesome/free-solid-svg-icons';

export default {
  props: {
    embedded_mode: {
      default: false,
    },
    embedded_filters: {
      default: null,
    },
  },
  data() {
    let offset = parseInt(this.$route.query.offset || 0);
    let limit = parseInt(this.$route.query.limit || 20);
    let current_page = Math.ceil((offset + limit) / limit);

    return {
      results: [],

      next_url: null,
      loading: false,
      total_items: null,
      current_page: current_page,
      data__contract_type: null,
      filters: {
        ordering: this.$route.query.ordering || [],
        search: this.$route.query.search || null,
        offset: offset,
        limit: limit,
        data__share: null,
        data__contract__portfolio: null,

      },

      contract_type_options: [
        { value: "fp", label: "Fresh Purchase" },
        { value: "ip", label: "IPO" },
        { value: "ri", label: "Right Issue" },
        { value: "ns", label: "Normal Sale" },
        { value: "bb", label: "Buy Back" },
      ],

      loading_exports: false,
      ongoing_exports: [],
      api_errors: {},
      search_results: []
    };
  },
  computed: {
    total_pages() {
      if (this.total_items == 0 || this.filters.limit == 0) return 1;
      return Math.ceil(this.total_items / this.filters.limit);
    },
    redoIcon: () => faRedo,
    excel: () => faFileExcel,
    filteredContracts() {
      if (this.data__contract_type) {
        const contractType = this.data__contract_type
        return this.results
          .filter((item) => item.contract_type === contractType)
      } else {
        return this.results;
      }
    }
  },
  mounted() {
    this.timer = null;
    this.init();
  },
  watch: {
    filters: {
      deep: true,
      handler(newV) {
        if (this.current_page == null) return;

        if (this.timer) clearTimeout(this.timer);

        this.timer = setTimeout(() => {
          console.log(newV);
          this.$router.push({ name: this.$route.name, query: newV });
        }, 800);
      },
    },
    "$route.query"(newV) {
      this.load_data(newV);
    },
    current_page(newV, oldV) {
      if (newV == oldV) return;
      this.filters.offset = (newV - 1) * this.filters.limit;
    },
  },
  beforeDestroy() {
    if (this.export_timer) clearTimeout(this.export_timer)
  },
  methods: {
    init() {
      this.load_data(this.filters);
    },
    calculate_page() {
      if (this.filters.offset == 0) this.current_page = 1;
      else
        this.current_page = Math.ceil(this.filters.offset / this.filters.limit);
    },
    load_data(filters = null, next = false) {
      if (this.checking_for_filters(filters)) return

      if (next && !this.next_url && !filters) return;
      let url =
        next && !filters
          ? this.next_url
          : this.$store.state.apiendpoints.summary_report;

      let payload = null;
      if (filters) payload = this.deepclone(filters);
      else payload = {};

      if ("ordering" in payload)
        if (Array.isArray(payload.ordering))
          payload.ordering = payload.ordering.join(",");

      if (this.embedded_mode && this.embedded_filters) {
        payload = { ...payload, ...this.embedded_filters };
      }

      this.loading = true;
      this.$vs.loading();

      Request(this, "GET", url, payload).then(
        (res) => {
          this.api_errors = {}
          this.results = res.results;
          this.total_items = res.count;
          this.next_url = res.next;
          this.loading = false;
          this.$vs.loading.close();
        },
        (err) => {
          this.$vs.notify({
            time: 2500,
            title: "Unknown Error",
            text: "An Error Occured. Please Try Again",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
          // if (!next) this.$router.push("/");
          this.api_errors = {}
          this.loading = false;
          this.$vs.loading.close();
        }
      );
    },
    refresh_exports() {
      this.loading_exports = true

      let url = this.$store.state.apiendpoints.excel_list

      let payload = {
        created_on: new Date().toISOString().split("T")[0],
        params__report_type: 'summary',
        limit: 2
      }

      Request(this, 'GET', url, payload).then(
        (res) => {
          this.ongoing_exports = res.results
          this.loading_exports = false
          if (this.ongoing_exports.filter((item) => ['p', 's', 'r'].includes(item.status)).length != 0) this.auto_refresh_export()
        },
        (err) => {
          this.loading_exports = false;
          this.$vs.notify({
            time: 2500,
            title: 'Error',
            text: "Unable to load current exports, please refresh to try again!",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      )
    },
    auto_refresh_export() {
      this.export_timer = setTimeout(() => {
        this.refresh_exports()
      }, 5000);
    },
    create_excel() {

      this.loading = true;
      this.$vs.loading();

      let corrected_keys = {}

      Object.keys(this.filters).filter((key) => !['search', 'ordering', 'offset', 'limit'].includes(key) && this.filters[key]).forEach(key => {
        corrected_keys[key] = this.filters[key]
      })

      let payload = {
        params: {
          "report_type": 'summary',
          "filters": corrected_keys
        }
      }

      let url = this.$store.state.apiendpoints.excel_create

      Request(this, 'POST', url, null, payload).then(
        (res) => {
          this.loading = false;
          this.$vs.loading.close();

          this.refresh_exports()

          this.$vs.notify({
            time: 3000,
            title: 'Success',
            text: "Your request to download file has been submitted",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })
        },
        (err) => {
          this.loading = false;
          this.$vs.loading.close();
          if (err.error) {
            this.api_errors = err.error

            this.$vs.notify({
              time: 2500,
              title: 'Error',
              text: "Please fix the errors and try again!",
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          } else {
            this.$vs.notify({
              time: 2500,
              title: 'Error',
              text: "Please try again later.",
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        }
      )
    },
    checking_for_filters(filters) {
      if (!filters.data__contract__portfolio) {
        this.api_errors = {
          "data__contract__portfolio": [
            "Portfolio is required.",
          ]
        }
        return true
      }

      if (!filters.data__share) {
        this.api_errors = {
          "data__share": [
            "Scrip is required.",
          ]
        }
        return true

      }

      return false
    },
  },
};
</script>

<style lang="scss">
.v-select {
  background: white;
}
</style>